import { createQueryKeys } from "@lukemorales/query-key-factory";
import api from "utils/api";
import {
  ICirculationResult,
  IMaterialResults,
  IMemberResult,
  IMemberWidgetSchema,
  IVisitorResult,
} from "./types";
import { endpoints } from "utils/endpoints";

export const dashboards = createQueryKeys("dashboard", {
  getMaterialWidgets: () => ({
    queryKey: [{}],
    queryFn: () =>
      api.get<IMaterialResults>(`${endpoints.dashboard.getMaterialWidgets}`),
  }),

  getVisitorWidgets: () => ({
    queryKey: [{}],
    queryFn: () =>
      api.get<IVisitorResult>(`${endpoints.dashboard.getVisitorWidgets}`),
  }),

  getMemberWidgets: (model:IMemberWidgetSchema) => ({
    queryKey: [model],
    queryFn: () =>
      api.post<IMemberResult>(`${endpoints.dashboard.getMemberWidgets}`,model),
  }),

  getCirculationWidgets: () => ({
    queryKey: [{}],
    queryFn: () =>
      api.get<ICirculationResult>(
        `${endpoints.dashboard.getCirculationWidgets}`
      ),
  }),
});
